export default __webpack_public_path__ + "static/media/entrust.e8bf7134.png";